import React, { useRef } from "react";
import ImageHandler from "../../utils/ImagesHandler";
import LazyImage from "../../components/Shared/LazyImage";
import { ErrorAlert } from "../../utils/Alerts";

import { Trans, useTranslation } from "react-i18next";

const EditableImage = ({
    state,
    stateSetter,
    attrName = "image",
    defaultImage = null,
    renderInline = null,
    disabled = false,
    className = "",
}) => {
    const uploadImageRef = useRef(null);
    const { t } = useTranslation();

    const handleFileClick = () => {
        if (disabled) {
            disabled && uploadImageRef.current.click();
        } else {
            uploadImageRef.current.click();
        }
    };

    const isExtensionValid = (path) => {
        var allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
        if (!allowedExtensions.exec(path)) {
            ErrorAlert(t("imageExtensionError"));
            return false;
        }
        return true;
    };

    const handleImageDelete = () => {
        stateSetter({ ...state, [attrName]: null });
        uploadImageRef.current.value = "";
    };

    const handleUploadImage = async (e) => {
        if (isExtensionValid(e.target.value)) {
            ImageHandler.formatImage(e, (image) => {
                stateSetter({ ...state, [attrName]: image });
            });
        }
    };

    return (
        <div className="upload-img-box flex">
            <div className="relative">
                {state[attrName] && (
                    <span
                        className="img-delete-icon"
                        onClick={handleImageDelete}
                    >
                        <i className="far fa-times-circle" />
                    </span>
                )}

                <div
                    className={`choose-img-wrapper ${className}`}
                    onClick={handleFileClick}
                >
                    <LazyImage
                        src={
                            state[attrName] ||
                            defaultImage ||
                            require("../../assets/images/neural.png").default
                        }
                        alt="Upload avatar"
                        className="card-header-img"
                    />

                    <input
                        ref={uploadImageRef}
                        type="file"
                        name="image"
                        accept="image/*"
                        className="hidden"
                        onChange={handleUploadImage}
                    />

                    <div className="choose-img-btn flex">
                        <i className="fas fa-plus-square"></i>
                        <span className="ml-2 mt-2">
                            <Trans i18nKey="upload">Upload</Trans>
                        </span>
                    </div>
                </div>
            </div>
            {renderInline && renderInline()}
        </div>
    );
};

export default EditableImage;
